import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import Panel from '@/components/Panel/Panel'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'

const Privacy = () => (
  <Main>
    <Container>
      <ExplicitHead
        description='EDHREC Privacy Policy'
        keywords='EDHREC,privacy,policy'
        title='Privacy Policy | EDHREC'
      />
      <SimpleHeader>Privacy Policy</SimpleHeader>
      <Panel>
        <h4 className='mb-3'>Mediavine Programmatic Advertising (Ver 1.1)</h4>
        <p>
          The Website works with Mediavine to manage third-party interest-based advertising appearing on the Website.
          Mediavine serves content and advertisements when you visit the Website, which may use first and third-party
          cookies. A cookie is a small text file which is sent to your computer or mobile device (referred to in this
          policy as a “device”) by the web server so that a website can remember some information about your browsing
          activity on the Website.
        </p>
        <p>
          First party cookies are created by the website that you are visiting. A third-party cookie is frequently used
          in behavioral advertising and analytics and is created by a domain other than the website you are visiting.
          Third-party cookies, tags, pixels, beacons and other similar technologies (collectively, “Tags”) may be placed
          on the Website to monitor interaction with advertising content and to target and optimize advertising. Each
          internet browser has functionality so that you can block both first and third-party cookies and clear your
          browser&apos;s cache. The &quot;help&quot; feature of the menu bar on most browsers will tell you how to stop
          accepting new cookies, how to receive notification of new cookies, how to disable existing cookies and how to
          clear your browser’s cache. For more information about cookies and how to disable them, you can consult the
          information at{' '}
          <a href='https://www.allaboutcookies.org/manage-cookies/' rel='noreferrer noopener nofollow' target='_blank'>
            All About Cookies
          </a>
          .
        </p>
        <p>
          Without cookies you may not be able to take full advantage of the Website content and features. Please note
          that rejecting cookies does not mean that you will no longer see ads when you visit our Site. In the event you
          opt-out, you will still see non-personalized advertisements on the Website.
        </p>
        <p>The Website collects the following data using a cookie when serving personalized ads:</p>
        <ul>
          <li>IP Address</li>
          <li>Operating System type</li>
          <li>Operating System version</li>
          <li>Device Type</li>
          <li>Language of the website</li>
          <li>Web browser type</li>
          <li>Email (in hashed form)</li>
        </ul>
        <p>
          Mediavine Partners (companies listed below with whom Mediavine shares data) may also use this data to link to
          other end user information the partner has independently collected to deliver targeted advertisements.
          Mediavine Partners may also separately collect data about end users from other sources, such as advertising
          IDs or pixels, and link that data to data collected from Mediavine publishers in order to provide
          interest-based advertising across your online experience, including devices, browsers and apps. This data
          includes usage data, cookie information, device information, information about interactions between users and
          advertisements and websites, geolocation data, traffic data, and information about a visitor’s referral source
          to a particular website. Mediavine Partners may also create unique IDs to create audience segments, which are
          used to provide targeted advertising.
        </p>
        <p>
          If you would like more information about this practice and to know your choices to opt-in or opt-out of this
          data collection, please visit{' '}
          <a href='https://thenai.org/opt-out/' rel='noreferrer noopener nofollow' target='_blank'>
            National Advertising Initiative opt out page
          </a>
          . You may also visit{' '}
          <a href='http://optout.aboutads.info/#/' rel='noreferrer noopener nofollow' target='_blank'>
            Digital Advertising Alliance website
          </a>{' '}
          and{' '}
          <a href='http://optout.networkadvertising.org/#' rel='noreferrer noopener nofollow' target='_blank'>
            Network Advertising Initiative website
          </a>{' '}
          to learn more information about interest-based advertising. You may download the AppChoices app at{' '}
          <a href='https://youradchoices.com/appchoices' rel='noreferrer noopener nofollow' target='_blank'>
            Digital Advertising Alliance’s AppChoices app
          </a>{' '}
          to opt out in connection with mobile apps, or use the platform controls on your mobile device to opt out.
        </p>
        <p>
          For specific information about Mediavine Partners, the data each collects and their data collection and
          privacy policies, please visit{' '}
          <a href='https://www.mediavine.com/ad-partners/' rel='noreferrer noopener nofollow' target='_blank'>
            Mediavine Partners
          </a>
          .
        </p>
      </Panel>
    </Container>
  </Main>
)

export default Privacy
